import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { setSubChildId } from "Administrator/modules/AdministratorModule";

export default store => ({
  path: "reviewer-setup",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "admin-announcements-manager" */ "./components"
      ),
      import(
        /* webpackChunkName: "admin-announcements-manager" */ "./modules/ReviewerSetupModule"
      ),
    ])
      .then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: importedModule1.NAME,
          reducer,
        });
        return component;
      })
      .catch(err => {
        return err;
      })
  ),
  onEnter() {
    store.dispatch(setSubChildId("ANNOUNCEMENTS_REVIEWER_SETUP"));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
});
